import React from "react";
import { useParams } from "react-router-dom";
import CallHelpCard from "./CallCard";

const RouteDetails = () => {
  const { routeSlug } = useParams();

  const [departure, arrival] = routeSlug?.split("-to-") || [];

  const formatCity = (str) =>
    str
      ?.split("-")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

  const formattedDeparture = formatCity(departure);
  const formattedArrival = formatCity(arrival);

  return (
    <div className="bg-gradient-to-br from-blue-50 to-blue-200 py-10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        
        {/* Support Card */}
        <CallHelpCard />

        {/* Main Content Container */}
        <div className="bg-white rounded-xl shadow-xl p-8 mt-8 border border-gray-200">
          
          {/* Title */}
          <h1 className="text-3xl sm:text-4xl font-bold text-orange-600 mb-6 text-center">
            Cheap Flights from {formattedDeparture} to {formattedArrival}
          </h1>

          <p className="text-gray-700 text-base leading-relaxed mb-6">
            Traveling is one of the best ways to refresh yourself—whether it’s 
            exploring local culture, enjoying nightlife, tasting new cuisines, 
            or discovering historical attractions. If you’re planning to travel 
            from {formattedDeparture} to {formattedArrival}, BookTrip4Me ensures 
            a smooth and affordable booking experience. This is one of the most 
            popular routes, offering everything from vibrant culture to 
            breathtaking views.
          </p>

          {/* Travel Documents */}
          <h2 className="text-xl font-semibold text-blue-700 mt-8 mb-3">
            Required Travel Documents
          </h2>
          <ul className="list-disc pl-6 text-gray-700 space-y-1">
            <li>Valid Passport</li>
            <li>Valid Visa</li>
            <li>Government-approved Photo ID</li>
            <li>Health Certificate (if required)</li>
            <li>Flight Tickets</li>
          </ul>

          {/* Best Time to Visit */}
          <h2 className="text-xl font-semibold text-blue-700 mt-8 mb-3">
            Best Time to Visit {formattedArrival}
          </h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            {formattedArrival} is a wonderful destination year-round. However, 
            the ideal season depends on your travel preference. Off-season often 
            provides cheaper flight prices and hotel rates, making it perfect 
            for budget travelers.
          </p>

          {/* How to Book */}
          <h2 className="text-xl font-semibold text-blue-700 mt-8 mb-3">
            How to Book Flights from {formattedDeparture} to {formattedArrival}
          </h2>
          <ol className="list-decimal pl-6 text-gray-700 space-y-1 mb-6">
            <li>Visit www.BookTrip4Me.com</li>
            <li>Select One-way or Round Trip</li>
            <li>Enter your departure and arrival cities</li>
            <li>Choose travel dates</li>
            <li>Click "Search"</li>
            <li>Select a flight that fits your budget</li>
            <li>Complete payment securely</li>
          </ol>

          {/* Tips */}
          <h2 className="text-xl font-semibold text-blue-700 mt-8 mb-3">
            Tips to Find Cheap Flights
          </h2>
          <ul className="list-disc pl-6 text-gray-700 space-y-1">
            <li><strong>Book Early:</strong> Avoid last-minute surges.</li>
            <li><strong>Compare Prices:</strong> Check multiple airlines before booking.</li>
            <li><strong>Set Fare Alerts:</strong> Track price drops easily.</li>
            <li><strong>Avoid Peak Season:</strong> Off-season = big savings.</li>
          </ul>

        </div>
      </div>
    </div>
  );
};

export default RouteDetails;
